import React from "react";
import AppText from "./AppText";
import Button from "../../presentational/Button";
import Links from "./Links";

interface AddPasskeyProps {
    isSubView?: boolean;
    serverError: string;
    isLoading: boolean;
    addPasskey: () => void;
}

const AddPasskey: React.FC<AddPasskeyProps> = ({ isSubView, serverError, isLoading, addPasskey }) => {
    const content = (
        <Button intent="primary" type="button" disabled={isLoading} onClick={addPasskey}>
            <AppText textKey="passkey-add-label" />
        </Button>
    );

    return isSubView ? (
        content
    ) : (
        <main>
            <div className="form-wrapper">
                <form className="form">
                    {serverError && <p className="server-error">{serverError}</p>}
                    <div className="form-header">
                        <img className="form-header-logo" src="https://assets.careevolutionapps.com/CareEvolution/Images/MDHD/mdhd-blue-bug-logo-centered.svg" alt="MyDataHelps Designer Logo" />
                        <h2>
                            <AppText textKey="passkey-title" />
                        </h2>
                        <p>
                            <AppText textKey="passkey-info" />
                        </p>
                    </div>
                    {content}
                </form>
                <Links />
            </div>
        </main>
    );
};

export default AddPasskey;
